// frontend/src/features/ogdb2/components/BAIDResultsTable.jsx
import React from "react";

function fmtPct(x) {
  if (x === null || x === undefined) return "—";
  if (typeof x === "number") return `${x.toFixed(4)}%`;
  const n = Number(String(x).replace(/,/g, ""));
  if (Number.isFinite(n)) return `${n.toFixed(4)}%`;
  return String(x);
}

function fmtDate(d) {
  try {
    return new Date(d).toLocaleString();
  } catch {
    return String(d || "");
  }
}

export default function BAIDResultsTable({ busy, rows, onOpen }) {
  const items = Array.isArray(rows) ? rows : [];
  return (
    <section className="rounded-2xl border border-gray-200 bg-white p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="text-sm font-semibold text-gray-800">
          Results{" "}
          <span className="text-xs font-normal text-gray-500">
            ({busy ? "…" : items.length})
          </span>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full text-xs">
          <thead>
            <tr className="text-left text-gray-500">
              <th className="py-2 pr-3">BAID</th>
              <th className="py-2 pr-3">Display</th>
              <th className="py-2 pr-3">RRC</th>
              <th className="py-2 pr-3">Lease</th>
              <th className="py-2 pr-3">Operator</th>
              <th className="py-2 pr-3">County</th>
              <th className="py-2 pr-3">Interest</th>
              <th className="py-2 pr-3">Ext Acct</th>
              <th className="py-2 pr-3">Updated</th>
              <th className="py-2 pr-3"></th>
            </tr>
          </thead>
          <tbody>
            {items.map((row) => {
              const u = row?.unit || {};
              const display = u?.display_name || u?.well_name || u?.lease_name || u?.rrc_number || `Unit ${u?.id}`;
              const leaseNumberSafe =
                u?.external_account_id === null || u?.external_account_id === undefined
                  ? "—"
                  : String(u.external_account_id).replace(/,/g, "");

              return (
                <tr key={u?.id || Math.random()} className="border-t border-gray-100">
                  <td className="py-2 pr-3 font-mono text-gray-900">{u?.id ?? "—"}</td>
                  <td className="py-2 pr-3 font-medium text-gray-900">{display}</td>
                  <td className="py-2 pr-3 text-gray-700">{u?.rrc_number || "—"}</td>
                  <td className="py-2 pr-3 text-gray-700">{u?.lease_name || "—"}</td>
                  <td className="py-2 pr-3 text-gray-700">{u?.operator || "—"}</td>
                  <td className="py-2 pr-3 text-gray-700">{u?.county || "—"}</td>
                  <td className="py-2 pr-3 text-gray-700">
                    {(u?.interest_type || "—") + " " + (u?.interest_pct !== null && u?.interest_pct !== undefined ? fmtPct(u.interest_pct) : "")}
                  </td>
                  <td className="py-2 pr-3 text-gray-700 font-mono">{leaseNumberSafe}</td>
                  <td className="py-2 pr-3 text-gray-600">{fmtDate(u?.updated_at)}</td>
                  <td className="py-2 pr-3">
                    <button
                      className="btn"
                      type="button"
                      disabled={busy}
                      onClick={() => onOpen?.(u)}
                    >
                      Open
                    </button>
                  </td>
                </tr>
              );
            })}

            {!busy && !items.length ? (
              <tr>
                <td colSpan={10} className="py-6 text-center text-xs text-gray-500">
                  No results. Pick a client and search.
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </section>
  );
}
